export default "__VITE_ASSET__5hprxfxl__"